import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { mockProjects, projectCategories } from "../../mocks/projects";
import { useState } from "react";

export default function Projects() {
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = activeFilter === "All"
    ? mockProjects
    : mockProjects.filter((p) => p.category === activeFilter);

  return (
    <div className="bg-arch-cream font-sans">
      <Header />
      <main>
        {/* Header */}
        <section className="pt-36 pb-14 px-8 lg:px-14 bg-white border-b border-arch-border">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-4">Portfolio</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h1 className="font-serif text-5xl lg:text-6xl text-arch-charcoal font-light leading-tight">
              Projects
            </h1>
            <p className="text-arch-gray text-sm font-light leading-relaxed max-w-sm">
              A selection of residential, multi-family, and hospitality projects across Santa Monica and greater Los Angeles.
            </p>
          </div>

          {/* Filter tabs */}
          <div className="flex items-center gap-2 mt-10 flex-wrap">
            {projectCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`px-4 py-2 text-xs tracking-[0.12em] uppercase font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  activeFilter === cat
                    ? "bg-arch-charcoal text-white"
                    : "border border-arch-border text-arch-gray hover:border-arch-charcoal hover:text-arch-charcoal"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </section>

        {/* Grid */}
        <section className="py-16 px-8 lg:px-14 bg-arch-cream">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((project) => (
              <Link key={project.id} to={`/projects/${project.id}`} className="group block cursor-pointer">
                <div className="relative w-full h-64 overflow-hidden rounded-lg mb-4">
                  <img
                    src={project.thumb}
                    alt={project.title + " — Studio 1323"}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute top-3 right-3">
                    <span className="bg-white/90 text-arch-charcoal text-xs tracking-wider uppercase px-2.5 py-1 rounded-full">
                      {project.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4 w-9 h-9 flex items-center justify-center bg-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-up-line text-arch-charcoal" />
                  </div>
                </div>
                <p className="text-arch-light text-xs tracking-wider uppercase mb-1">{project.location} · {project.year}</p>
                <h2 className="font-serif text-xl text-arch-charcoal font-light">{project.title}</h2>
                <p className="mt-1 text-arch-gray text-xs font-light line-clamp-2">{project.description}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 px-8 lg:px-14 bg-white border-t border-arch-border text-center">
          <h2 className="font-serif text-3xl text-arch-charcoal font-light mb-4">Have a project in mind?</h2>
          <p className="text-arch-gray text-sm font-light mb-8">Let&apos;s discuss your vision — initial consultations are complimentary.</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-arch-charcoal text-white px-8 py-4 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-arch-black transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request Consultation <i className="ri-arrow-right-line" />
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}
